
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.596 6.277a4.404 4.404 0 118.807 0 4.404 4.404 0 01-8.807 0zM9 .123a6.154 6.154 0 00-3.532 11.194 10.111 10.111 0 00-5.227 4.42.875.875 0 101.515.875 8.365 8.365 0 0114.488 0 .875.875 0 001.515-.876 10.116 10.116 0 00-5.228-4.419A6.154 6.154 0 009 .123z","fill":"currentColor"}})])
          )
        }
      }
    